import { encode, decode } from 'js-base64';
//import { Logger } from './logger';

export class BackendService 
{
    static getServiceUrl(domain)
    {
      let host = null;
      if(domain == 'localhost')
      {
        host = "http://localhost:5000/";
      }
      else
      {
        host = "https://backend.aipredict.us/";
      }
      return host;
    }
    
    static sendUserActionAnalytics(userActionAnalytics, domain)
    {
      try
      {
        let scripts = document.querySelectorAll("script[name='ai_script']");
        let scriptsArray = Array.prototype.slice.call(scripts);
        scriptsArray.forEach(function(childScript){
          childScript.parentNode.removeChild(childScript);
        });
      }
      catch(ex)
      {
        console.log(ex);
      }
      
      let json = JSON.stringify(userActionAnalytics);
      let compressedJson = encode(json);

      if(compressedJson.indexOf('/') !== -1)
      {
        compressedJson = compressedJson.replace("/", "_");
      }
      let script = document.createElement('script');

      let host = this.getServiceUrl(domain);
      let url = host + "data/load/" + compressedJson + '/response.js';

      script.setAttribute("name", "ai_script");
      script.setAttribute('async', true);
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', url);
      script.setAttribute('id','ai_sendUserAction_' + userActionAnalytics.id);
      document.body.appendChild(script);
    }
}

export class DataLayerService
{
    static send(userPush)
    {
      dataLayer.push({
        'event': userPush.eventName,
        'class': userPush.userType,
        'ai_id': userPush.userId,
        'ai_prediction': Number(userPush.weightedDecile) / 10,
        'ai_action': userPush.userActionType,
        'ai_fc_decile': userPush.fcDecile,
        'ai_fc_source': userPush.fcUserSource,
        'ai_fc_medium': userPush.fcUserMedium,
        'ai_fc_campaign': userPush.fcUserCampaign,
        'ai_fc_source_timestamp': userPush.fcUserTimestamp,
        'ai_timestamp': userPush.userActionTimestamp,
        
        'ai_prediction_decile': userPush.weightedDecile,
        'ai_cl_decile': userPush.clDecile,
        'ai_rg_decile': userPush.rgDecile,
        'ai_st_decile': userPush.stDecile,
        'ai_sg_decile': userPush.sgDecile,
        'ai_clstr_decile': userPush.clstrDecile,
        'ai_whispering_type': userPush.whisperingType,

        'ai_ch_prediction': 'Ch' + userPush.weightedDecile,
        'ai_ch_cl': 'Ch' + userPush.clDecile,
        'ai_ch_rg': 'Ch' + userPush.rgDecile,
        'ai_ch_st': 'Ch' + userPush.stDecile,
        'ai_ch_sg': 'Ch' + userPush.sgDecile,
        'ai_ch_clstr': 'Ch' + userPush.clstrDecile
      });

    }
}